export const DIST_PORTFOLIOS = [1, 2, 3] as const;
export const DIST_LABELS: Record<number, string> = { 1: "Low", 2: "Medium", 3: "High" };
export const distLabel = (p: number) => DIST_LABELS[p] ?? `Dist${p}`;
